import { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../lib/i18n/LanguageContext';
import SEO from '../../components/SEO';

// Import the new modular components
import CareersHero from './CareersHero';
import CareersWhyJoin from './CareersWhyJoin';
import CareersApplicationForm from './CareersApplicationForm';

const Careers = () => {
  const { t } = useLanguage();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [t]);

  // Structured data for careers page
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'JobPosting',
    title: 'Restaurant Staff',
    description: t.careers.hero.subtitle,
    datePosted: new Date().toISOString().split('T')[0],
    validThrough: new Date(new Date().setMonth(new Date().getMonth() + 3))
      .toISOString()
      .split('T')[0],
    employmentType: 'FULL_TIME',
    hiringOrganization: {
      '@type': 'Organization',
      name: 'Rossopomodoro Reykjavik',
      sameAs: 'https://rossopomodoro.is',
    },
    jobLocation: {
      '@type': 'Place',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Laugavegi 40a',
        addressLocality: 'Reykjavík',
        postalCode: '101',
        addressCountry: 'IS',
      },
    },
    baseSalary: {
      '@type': 'MonetaryAmount',
      currency: 'ISK',
      value: {
        '@type': 'QuantitativeValue',
        unitText: 'MONTH',
      },
    },
  };
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.4 }}
    >
      <SEO
        title={`${t.careers.hero.title} | Rossopomodoro`}
        description="Join Rossopomodoro Reykjavik team! Career opportunities at best Italian restaurant downtown. Work with authentic Italian cuisine, competitive benefits. Apply now."
        canonical="https://rossopomodoro.is/careers"
        keywords="Italian restaurant jobs Reykjavik, Rossopomodoro careers, restaurant jobs downtown Reykjavik, chef jobs, server jobs, kitchen staff, hospitality careers"
        ldjson={structuredData}
      />

      {/* Compose the modular components */}
      <CareersHero />
      <CareersWhyJoin />
      <CareersApplicationForm />
    </motion.div>
  );
};

export default Careers;
